import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon, MapPinIcon, PrinterIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  return <section id="contact" className="py-24 bg-white" data-id="element-58">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="mb-16 text-center max-w-2xl mx-auto" data-id="element-60">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-61">
            <div className="h-[1px] w-8 bg-border" data-id="element-62" />
            <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-63">
              Get In Touch
            </span>
            <div className="h-[1px] w-8 bg-border" data-id="element-64" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-65">
            Request a Consultation
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-8" data-id="element-66">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-3 bg-warm-grey rounded-xl p-8 md:p-10 shadow-sm border border-border/50" data-id="element-67">
            {isSuccess ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-68">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-69">
                  <MailIcon className="w-8 h-8" data-id="element-70" />
                </div>
                <h3 className="text-2xl font-bold text-charcoal mb-2" data-id="element-71">
                  Message Sent!
                </h3>
                <p className="text-body" data-id="element-72">
                  Thank you for reaching out. We will get back to you shortly.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-73">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-74">
                  <div className="space-y-2" data-id="element-75">
                    <label htmlFor="name" className="block text-sm font-medium text-charcoal" data-id="element-76">
                      Full Name
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all" placeholder="John Doe" data-id="element-77" />
                  </div>
                  <div className="space-y-2" data-id="element-78">
                    <label htmlFor="email" className="block text-sm font-medium text-charcoal" data-id="element-79">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all" placeholder="john@example.com" data-id="element-80" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-81">
                  <div className="space-y-2" data-id="element-82">
                    <label htmlFor="phone" className="block text-sm font-medium text-charcoal" data-id="element-83">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all" placeholder="(555) 123-4567" data-id="element-84" />
                  </div>
                  <div className="space-y-2" data-id="element-85">
                    <label htmlFor="service" className="block text-sm font-medium text-charcoal" data-id="element-86">
                      Service Needed
                    </label>
                    <select id="service" name="service" value={formData.service} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-body" data-id="element-87">
                      <option value="" data-id="element-88">Select a service...</option>
                      <option value="general" data-id="element-89">General Inquiry</option>
                      <option value="maintenance" data-id="element-90">Maintenance</option>
                      <option value="construction" data-id="element-91">Construction</option>
                      <option value="consulting" data-id="element-92">Consulting</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-93">
                  <label htmlFor="message" className="block text-sm font-medium text-charcoal" data-id="element-94">
                    Message
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-border bg-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all resize-none" placeholder="How can we help you?" data-id="element-95" />
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-8 py-4 bg-primary hover:bg-primary-light text-white font-medium rounded-md shadow-sm transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center" data-id="element-96">
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>}
          </motion.div>

          {/* Contact Details */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-2 space-y-8" data-id="element-97">
            <div className="bg-white rounded-xl p-8 border border-border shadow-sm" data-id="element-98">
              <h3 className="text-xl font-bold text-charcoal mb-6" data-id="element-99">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-100">
                <div data-id="element-101">
                  <p className="text-sm font-bold text-charcoal uppercase tracking-wider mb-1" data-id="element-102">
                    Business Development
                  </p>
                  <p className="text-body font-medium" data-id="element-103">Dencell Green</p>
                </div>

                <div className="flex items-start gap-4" data-id="element-104">
                  <div className="w-10 h-10 rounded-full bg-warm-grey flex items-center justify-center shrink-0" data-id="element-105">
                    <MailIcon className="w-5 h-5 text-primary" data-id="element-106" />
                  </div>
                  <div data-id="element-107">
                    <p className="text-sm font-medium text-charcoal mb-1" data-id="element-108">
                      Email
                    </p>
                    <a href="mailto:dencell.green@kingsburymc.com" className="text-body hover:text-primary transition-colors" data-id="element-109">
                      dencell.green@kingsburymc.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-110">
                  <div className="w-10 h-10 rounded-full bg-warm-grey flex items-center justify-center shrink-0" data-id="element-111">
                    <PhoneIcon className="w-5 h-5 text-primary" data-id="element-112" />
                  </div>
                  <div data-id="element-113">
                    <p className="text-sm font-medium text-charcoal mb-1" data-id="element-114">
                      Phone
                    </p>
                    <a href="tel:4162089236" className="text-body hover:text-primary transition-colors" data-id="element-115">
                      416 208 9236
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-116">
                  <div className="w-10 h-10 rounded-full bg-warm-grey flex items-center justify-center shrink-0" data-id="element-117">
                    <MapPinIcon className="w-5 h-5 text-primary" data-id="element-118" />
                  </div>
                  <div data-id="element-119">
                    <p className="text-sm font-medium text-charcoal mb-1" data-id="element-120">
                      Address
                    </p>
                    <address className="text-body not-italic" data-id="element-121">
                      1-81 Milliken Blvd
                      <br data-id="element-122" />
                      Scarborough, ON M1V 1V3
                    </address>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="w-full h-48 bg-warm-grey rounded-xl border border-border overflow-hidden relative" data-id="element-123">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80')] bg-cover bg-center opacity-40 grayscale" data-id="element-124" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-125">
                <div className="bg-white px-4 py-2 rounded-md shadow-md flex items-center gap-2" data-id="element-126">
                  <MapPinIcon className="w-4 h-4 text-primary" data-id="element-127" />
                  <span className="text-sm font-medium text-charcoal" data-id="element-128">
                    Scarborough, Ontario
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}